import type { SocialUserSearchDto } from "Infrastructure/Api/Api";
import { Resources } from "Translations/Resources";

const RESOURCES = Resources.Chat.NewChat;

/**
 * Name to show for a search result. A private persona discloses no name to strangers
 * (server-side rule), so their handle is the identity we show instead.
 */
export const getUserDisplayName = (
  { displayName, handle }: SocialUserSearchDto,
  t: (key: string) => string,
) => displayName || (handle ? `@${handle}` : t(RESOURCES.UnknownUser));
